import { Platform } from 'react-native';
import { JDNativeSystem } from '@jdreact/jdreact-core-lib';

const ua = (navigator && navigator.userAgent) || '';

const isWeb = Platform.OS === 'web';
const isIOS = isWeb
    ? ua.indexOf('like Mac OS X') > -1
    : Platform.OS === 'ios';
const isAndroid = Platform.OS === 'android';

let isJRApp = false;
if (isWeb) {
    const ua = (navigator && navigator.userAgent) || '';
    isJRApp = /application=JDJR-App/.test(ua);
}

let isJDApp = true;
if (isWeb) {
    const ua = (navigator && navigator.userAgent) || '';
    isJDApp = /jdapp/.test(ua);
}

function len(str) {
    if (!str) {
        return 0;
    }
    return str.length;
}
/**
*
* @param {string} [version] 版本号.
* @param {string} [n] 版本号长度.
* @param {string} [p] 当前指针.
* @returns {string} Returns the trimmed string.
*/
function getNextChunk(version, n, p) {
    if (p > n - 1) {
        return [0, p];
    }

    let pEnd = p;

    while (pEnd < n && version[pEnd] !== '.') {
        pEnd += 1;
    }
    let i;
    if (pEnd !== n - 1) {
        i = Number(version.slice(p, pEnd));
    } else {
        i = Number(version.slice(p, n));
    }
    p = pEnd + 1;

    return [i, p];
}
/**
*
* @param {string} [version1] 版本1.
* @param {string} [version2] 版本2.
* @returns {string} 1: 大于， 0: 等于， -1: 小于.
* @example
*
* compareVersion('1.01', '1.001')
* // => 0
*
*  * compareVersion('10.1.0', '9.10.10')
* // => 1
*/
function compareVersion(version1 = '', version2 = '') {
    let i1, i2;
    let p1 = 0;
    let p2 = 0;
    let n1 = len(version1);
    let n2 = len(version2);

    while (p1 < n1 || p2 < n2) {
        [i1, p1] = getNextChunk(version1, n1, p1);
        [i2, p2] = getNextChunk(version2, n2, p2);
        if (i1 !== i2) {
            return i1 > i2 ? 1 : -1;
        }
    }
    return 0;
}

async function isSupportSceneId() {
    let version = await JDNativeSystem.getClientVersion().catch(err => {
        console.log('获取版本号失败', err);
        return false;
    });
    if (isWeb) {
        version = getWebClientVersion();
    }

    let isSupport = false;
    const ua = (navigator && navigator.userAgent) || '';
    const isIOSWeb = ua.indexOf('like Mac OS X') > -1;
    const isAndroidWeb = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

    // 安卓11.6.5及以上支持， 11.3.8版本也支持, ios,11.8.1及以上支持， web端跟随app版本
    if (isAndroid || isAndroidWeb) {
        isSupport = compareVersion(version, '11.6.5') >= 0;
        if (compareVersion(version, '11.3.8') === 0) {
            isSupport = true;
        }
    } else if (isIOS || isIOSWeb) {
        isSupport = compareVersion(version, '11.8.1') >= 0;
    }
    return isSupport;
}

function getWebClientVersion() {
    let clientVersion = '';
    if (isWeb) {
        const ua = (navigator && navigator.userAgent) || '';

        // 京东app
        if (isJDApp) {
            const client = ua.split(';');

            clientVersion = (client && client[2]) || '';
        }
    }
    return clientVersion;
}

export {
    isJRApp,
    isWeb,
    isIOS,
    isAndroid,
    isJDApp,
    compareVersion,
    isSupportSceneId,
    getWebClientVersion
};
